export default __webpack_public_path__ + "static/media/twitter.57573394.png";